import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {InfluencerDetail, AddInfluencerGroup, ContactPermissionStatus} from '../../../models/influencer';
import { Location } from '@angular/common';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {CommonConstant, InfluencerTabName, InfluencerTab, CampaignInfluencerStatus} from '../../app.constants';
import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group-details/group.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { AddInfluencersCampaign } from '../../../models/campaign/add-influencers-campaign';
import { TranslateService } from '@ngx-translate/core';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { InfluencerCampaignActivity } from '../../../models/influencer-campaign';
import { PdfViewerService } from '../pdf-viewer/pdf-viewer.service';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {EventTrackerService, Page, UserActionType, ActivePages, TargetType, ActionSource, ActionDetails} from '../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../models/event-tracker';
import {InvalidAction} from '../../../models/user';
import {CacheService} from '../../services/cache/cache.service';
import {CommunicationService} from '../../services/communication/communication.service';
import {Conversation, ShortMessageStatus} from '../../../models/inbox';
import {AppSettings} from '../../utils/app-settings';
import {DeletePostCampaign} from '../../../models/campaign';
import {InfluencerCampaignActivityComponent} from './influencer-campaign-activity/influencer-campaign-activity.component';
import {DemographicComponent} from './demographic/demographic.component';
import {MoveInfluencerFromGroupComponent} from '../group-details/move-influencer-from-group/move-influencer-from-group.component';
import {HttpErrorResponse} from '@angular/common/http';

enum InfluencerCampaignParam {
  removedCampaign = '0',
}

@Component({
  selector: 'app-influencer',
  templateUrl: './influencer.component.html',
  styleUrls: ['./influencer.component.scss']
})
export class InfluencerComponent extends AbstractAchooComponent implements OnInit, OnDestroy {
  @ViewChild('AddInfluencerToGroupErrorPopup')
  public addInfluencerToGroupErrorPopup: AchooPopupComponent;
  @ViewChild('AddInfluencerToGroup') addInfluencerToGroup: MoveInfluencerFromGroupComponent;
  private addInfluencerToGroupErrorPopupRef;

  public influencerId: number;
  public groupId: number;
  public influencer: InfluencerDetail;
  public showCountryFlagIcon: boolean | true;
  public fromPath: string;
  // keep id to back to campaign list
  public selectedCampaignId: number;

  public influencerGroupList: any[];
  public campaignList: any[];
  public activeBottomBar: boolean;
  public isEnableAddToGroup: boolean;
  public isEnableAddToCampaign: boolean;
  public showCreateNewGroupFragment: boolean;
  public selectedCampaign: AddInfluencersCampaign = new AddInfluencersCampaign();
  public selectedCampaignNotificationMsg: string;
  public selectedInfluencerCampaign: InfluencerCampaignActivity = new InfluencerCampaignActivity;
  public campaignInfluencerId: number;
  public pdfUrl: string;
  // influencer conversation
  public influencerConversation: Conversation;
  public showActivityLog = true;
  public isArchivedCampaign: boolean;

  @ViewChild('AlertAddInfluencerToGroupSuccess')
  public alertAddInfluencerToGroupSuccess: AchooPopupComponent;
  @ViewChild('AlertAddInfluencerToCampaignSuccess')
  public alertAddInfluencerToCampaignSuccess: AchooPopupComponent;
  @ViewChild('ConfirmRemoveFromCampaign')
  public confirmRemoveFromCampaign: AchooPopupComponent;
  @ViewChild('AlertPdfDownloadPending')
  public alertPdfDownloadPending: AchooPopupComponent;
  @ViewChild('ConfirmDeletePostFromCampaign')
  public confirmDeletePostFromCampaign: AchooPopupComponent;
  @ViewChild('NotifyPostDeletedSuccess')
  public notifyPostDeletedSuccess: AchooPopupComponent;
  @ViewChild('NotifyPostDeletedError')
  public notifyPostDeletedError: AchooPopupComponent;
  @ViewChild('InfluencerCampaignActivity')
  public influencerCampaignActivity: InfluencerCampaignActivityComponent;
  @ViewChild('InfluencerDemographic')
  public influencerDemographic: DemographicComponent;
  @ViewChild('AddInfluencerToCampaignErrorPopup')
  public addInfluencerToCampaignErrorPopup: AchooPopupComponent;
  @ViewChild('NotifyPdfExportError')
  public notifyPdfExportError: AchooPopupComponent;
  public notifyPdfExportErrorMessage: string;

  public hiddenBackButton = false;
  public activeTabIndex: number | 1;
  public exportPdfSubcription: Subscription;
  public target: string;

  public pendingAddInfluencerToGroup: AddInfluencerGroup;
  public addInfluencerToGroupSuccessMessage: string;
  public channelFollowerParam: string;
  private insightChannelParam: number;
  private demographicChannelParam: number;

  // store list post to delete
  private postToDelete: DeletePostCampaign[];
  private campaignNeedToDeletePost: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private influencerService: InfluencerService,
              public location: Location,
              private placeholderService: PlaceholderVisibilityService,
              protected userService: UserService,
              private groupService: GroupService,
              private campaignService: CampaignService,
              private influencerGroupService: InfluencerGroupsService,
              private modalService: ModalService,
              private eventTracker: EventTrackerService,
              private pdfViewerService: PdfViewerService,
              private translateService: TranslateService,
              private pdfService: PdfExportService,
              private cacheService: CacheService,
              private communicationService: CommunicationService,
              private title: Title) {
    super(userService);
  }

  ngOnInit() {
    this.route.params.subscribe(res => {
      this.influencerId = res.id;
    });
    super.ngOnInit();
    this.route.queryParams.subscribe(params => {
      this.groupId = params.group_id && Number(params.group_id);
      // check hidden back button
      this.hiddenBackButton = params.hideBackButton;
      // keep target page
      this.target = params.target;
      // get campaign influencer details if tab is campaign
      if (params.campaignInfluencerId) {
        this.campaignInfluencerId = params.campaignInfluencerId;
      }
    });

    this.route.data.subscribe(res => {
      this.activeTabIndex = res.order;
    });

    this.route.queryParams.subscribe(params => {
      this.fromPath = params.from_path;
      this.selectedCampaignId = Number(params.selectedCampaign);
    });

    // using cached data. Only fetch once time
    const influencerDetailsData = this.influencerService.influencerDetails;
    if (influencerDetailsData && influencerDetailsData.id === Number(this.influencerId)) {
      this.initializeInfluencerPage(influencerDetailsData);
    } else {
      // deleted cached data
      this.influencerService.clearCachedInfluencerData();
      if (!this.cacheService.has(`influencer_${this.influencerId}`)) {
        this.placeholderService.show(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
      }
      this.cacheService.get(`influencer_${this.influencerId}`, this.influencerService.getInfluencer(this.influencerId))
        .subscribe((data) => {
          this.initializeInfluencerPage(data);
          this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
      });
    }
  }

  checkCreditAvailability(influencerId, companyId) {
    this.influencerService.checkInfluencerCreditAvailability(influencerId, companyId);
  }

  changeDemographicSource(channelId) {
    this.demographicChannelParam = channelId;
    this.insightChannelParam = channelId;
    this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
  }

  changeChannel(data) {
    this.insightChannelParam = data.channel;
    this.demographicChannelParam = data.channel;
    this.channelFollowerParam = data.channelFollower;
    this.updateUrl(data.activeTab);
  }

  private updateUrl(activeTab) {
    let params = {
      activeAccount: this.companyId,
    };
    if (this.groupId) {
      params = Object.assign({}, params, { group_id: this.groupId });
    }
    if (this.hiddenBackButton) {
      params = Object.assign({}, params, { hideBackButton: this.hiddenBackButton });
    }
    if (this.campaignInfluencerId) {
      params = Object.assign({}, params, { campaignInfluencerId: this.campaignInfluencerId });
    }
    if (this.fromPath) {
      params = Object.assign({}, params, { from_path: this.fromPath });
    }
    if (this.selectedCampaignId) {
      params = Object.assign({}, params, { selectedCampaign: this.selectedCampaignId });
    }
    if (this.target) {
      params = Object.assign({}, params, { target: this.target });
    }
    if (this.insightChannelParam) {
      params = Object.assign({}, params, { insightChannel: this.insightChannelParam });
    }
    if (this.channelFollowerParam) {
      params = Object.assign({}, params, { channelFollower: this.channelFollowerParam });
    }
    if (this.demographicChannelParam) {
      params = Object.assign({}, params, { demographicChannel: this.demographicChannelParam });
    }
    const url = this.router.createUrlTree(['influencer', this.influencerId, activeTab], { queryParams: params })
      .toString();

    this.location.go(url);
  }

  private initializeInfluencerPage(influencerData) {
    if (!influencerData) {
      return;
    }
    this.influencer = influencerData;
    // pre-load data by given channel from url
    this.updateActiveChannelFromUrl(this.influencer.channels);
    // update browser title
    this.title.setTitle(this.translateService.instant('INFLUENCER.TITLE', {
      influencerName: this.influencer.name
    }));
    this.showCountryFlagIcon = true;
    // segment track event view details group
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_DETAILS, {
      id: influencerData.id,
      name: influencerData.name,
      type: TargetType.INFLUENCER
    }, undefined, undefined, {
      type: ActivePages.INFLUENCER_DETAILS,
      name: this.influencer.name,
      id: influencerData.id
    });
  }

  private updateActiveChannelFromUrl(influencerChannels) {
    this.route.queryParams.subscribe(params => {
      if (params.insightChannel) {
        const selectedChannel = influencerChannels.find(c => c.id === Number(params.insightChannel));
        if (selectedChannel && AppSettings.getActivePlatformList().indexOf(selectedChannel.platformName.toLowerCase()) >= 0) {
          this.influencerService.updateActiveChannel(selectedChannel);
        }
      }
    });
  }

  private loadInfluencerCommunication(influencerId, companyId) {
    this.communicationService.fetchInfluencerConversation(companyId, influencerId).subscribe((res) => {
      this.influencerConversation = res;
    }, (error) => {
      if (error instanceof HttpErrorResponse && error.status === 404) {
        this.influencerConversation = {
          id: 0,
          createdAt: null,
          lastUpdated: null,
          messages: [],
          name: null,
          participants: [],
          status: ShortMessageStatus.Normal,
          isHidden: false,
          isJoined: true,
          isSelected: false,
          permission: ContactPermissionStatus.UNDEFINED
        };
      }
    });
  }

  companyChangeCallback(companyId) {
    this.cacheService.get(`group_list_${companyId}`, this.influencerGroupService.getInfluencerGroupShortList(companyId))
      .subscribe((res: any) => {
        this.influencerGroupList = res.map(group => ({
          id: group.id,
          name: group.name
        }));
    });

    // load list campaign
    this.cacheService.get(`campaign_list_${companyId}`, this.campaignService.getCampaignShortListForCompany(companyId))
      .subscribe((res: any) => {
        this.campaignList = res ? res.filter(campaignItem => campaignItem.status !== CampaignInfluencerStatus.ARCHIVED).map(
          (campaign) => ({
            id: campaign.id,
            name: campaign.name,
            brief: campaign.brief
          })
        ) : [];
      });
    // load influencer communication
    this.loadInfluencerCommunication(this.influencerId, companyId);
    this.checkCreditAvailability(this.influencerId, this.companyId);
    if (this.influencerCampaignActivity) {
      this.influencerCampaignActivity.campaignInfluencerId = undefined;
      this.influencerCampaignActivity.initialize();
    }
  }

  ngOnDestroy() {
    // update browser title
    this.title.setTitle(this.translateService.instant('APP.TITLE' ));
    this.influencerService.updateActiveChannel(null);
  }

  shouldShowActionButtonForCampaign() {
    if (!this.influencerCampaignActivity || !this.isActiveCampaignTab) {
      return false;
    }
    return this.influencerCampaignActivity.selectedCampaign && this.influencerCampaignActivity.selectedCampaign.campaignInfluencerId > 0;
  }

  getActiveCampaignName() {
    if (!this.influencerCampaignActivity || !this.isActiveCampaignTab) {
      return null;
    }
    return this.influencerCampaignActivity.selectedCampaign.name;
  }

  showOverview() {
    this.activeTabIndex = InfluencerTab.OVERVIEW;
    this.updateUrl(InfluencerTabName.OVERVIEW);
  }

  showInsight() {
    this.activeTabIndex = InfluencerTab.INSIGHT;
    this.updateUrl(InfluencerTabName.INSIGHT);
  }

  showDemographics() {
    this.activeTabIndex = InfluencerTab.DEMOGRAPHIC;
    this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
  }

  showActivity() {
    this.activeTabIndex = InfluencerTab.ACTIVITY;
    this.updateUrl(InfluencerTabName.ACTIVITY);
  }

  showCampaign() {
    this.activeTabIndex = InfluencerTab.CAMPAIGN;
    this.updateUrl(InfluencerTabName.CAMPAIGN);
  }

  private getCurrentActiveChannel() {
    return this.influencerService.currentActiveChannel ? this.influencerService.currentActiveChannel.id : null;
  }

  back() {
    if (this.fromPath && !this.selectedCampaignId) {
      this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId));
      return this.router.navigate([this.fromPath]);
    } if (this.fromPath && this.selectedCampaignId) {
      this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId, this.campaignInfluencerId));
      return this.router.navigate([this.fromPath], { queryParams: { selectedCampaign: this.selectedCampaignId } });
    } else if (this.groupId && this.groupId !== 0) {
      this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId));
      return this.router.navigate(['groups', this.groupId]);
    } else {
      this.cacheService.disableCacheRemoving();
      return this.location.back();
    }
  }

  showAddToGroup() {
    this.activeBottomBar = true;
    this.isEnableAddToGroup = true;
  }

  showAddToCampaign() {
    this.activeBottomBar = true;
    this.isEnableAddToCampaign = true;
  }

  hideBottomBar(needToClearPendingData?: boolean) {
    if (needToClearPendingData) {
      this.pendingAddInfluencerToGroup = null;
    }
    this.activeBottomBar = false;
    this.isEnableAddToGroup = false;
    this.isEnableAddToCampaign = false;
    this.showCreateNewGroupFragment = false;
  }

  addCurrentInfluencerToGroup(moveInfluencerGroup: AddInfluencerGroup) {
    if (!moveInfluencerGroup.influencer_group_id) {
      return;
    }
    moveInfluencerGroup.influencerList = [Number(this.influencerId)];
    this.hideBottomBar();
    this.pendingAddInfluencerToGroup = moveInfluencerGroup;
    if (moveInfluencerGroup.addForReview) {
      this.addInfluencerToGroupAsPending(moveInfluencerGroup);
    } else {
      this.addInfluencerToGroupAsNormal(moveInfluencerGroup);
    }
  }

  private addInfluencerToGroupAsNormal(influencerToAdd: AddInfluencerGroup) {
    this.groupService.addInfluencerToGroup(influencerToAdd).subscribe((res: any) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd);
      this.sendChamMixpanelEvent(false);
    }, (err) => {
      this.showAddToGroup();
      if (err.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Group', err.error.message);
        this.sendInvalidActionToSegement(this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message,
          influencerToAdd.influencerList.length, this.userService.maxGroupInfluencers, false),
          influencerToAdd, null);
      } else {
        this.addInfluencerToGroupErrorPopupRef = this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
      }
    });
  }

  private addInfluencerToGroupAsPending(influencerToAdd: AddInfluencerGroup) {
    this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe((res) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd);
    }, err => {
      this.showAddToGroup();
      this.addInfluencerToGroupErrorPopupRef = this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
    });
  }

  private afterAddingInfluencerToGroupSuccess(influencerToAdd: AddInfluencerGroup) {
    this.showAlertSuccessAddInfluencerToGroup(influencerToAdd.addForReview);
    this.pendingAddInfluencerToGroup = null;
    // track event to Segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
        id: influencerToAdd.influencer_group_id,
        name: influencerToAdd.influencerGroupName,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.BOTTOM_BAR,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerToAdd
      }, undefined,
      this.activePage
    );
  }

  addInfluencerToCampaign(addInfluencerCampaign: AddInfluencersCampaign) {
    if (!addInfluencerCampaign.campaign_id) {
      return;
    }
    // prepare influencer data to webservice
    addInfluencerCampaign.influencers = [{
      influencer_id: Number(this.influencerId),
      action: CommonConstant.ADD_ACTION,
      status: addInfluencerCampaign.is_accepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase() : ''
    }];

    this.campaignService.addInfluencerToCampaign(addInfluencerCampaign).subscribe((res: any) => {
      this.selectedCampaignNotificationMsg = addInfluencerCampaign.campaign_name;
      this.showAlertSuccessAddInfluencerToCampaign();
      this.hideBottomBar();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: addInfluencerCampaign.campaign_id,
        name: addInfluencerCampaign.campaign_name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.BOTTOM_BAR,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...addInfluencerCampaign
      }, undefined,
        this.activePage
      );
      if (!addInfluencerCampaign.is_accepted) {
        this.sendChamMixpanelEvent(true);
      }
      this.clearCachedCampaignInfluencersData(addInfluencerCampaign.campaign_id);
      this.userService.triggerUpdateActivatedInfluencers();
    }, (err) => {
      if (err.error.data === 'invalid_level') {
        this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
        this.sendInvalidActionToSegement(
          this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message, addInfluencerCampaign.influencers.length,
            this.userService.maxCampaignInfluencers, true), null, addInfluencerCampaign);
      }
      if (err.error.data === 'archived_campaign') {
        this.modalService.openInCenter(this.addInfluencerToCampaignErrorPopup);
      }
    });
  }

  private sendChamMixpanelEvent(isAddedToCampaign) {
    if (isAddedToCampaign) {
      this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
    } else {
      this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
    }
  }

  private sendInvalidActionToSegement(limitInfo, influencerAddToGroup, influencerAddToCampaign) {
    const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
      limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
    // send event when adding influencer to group
    if (influencerAddToGroup) {
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
        id: influencerAddToGroup.influencer_group_id,
        name: influencerAddToGroup.influencerGroupName,
        type: TargetType.INFLUENCER
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.BOTTOM_BAR,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerAddToGroup
      }, undefined, {
        type: ActivePages.INFLUENCER_DETAILS,
        name: this.influencer.name,
        id: this.influencer.id,
      });
    }

    // send event when adding to Campaign
    if (influencerAddToCampaign) {
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
        id: influencerAddToCampaign.campaign_id,
        name: influencerAddToCampaign.campaign_name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.BOTTOM_BAR,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerAddToCampaign
      }, undefined, {
        type: ActivePages.INFLUENCER_DETAILS,
        name: this.influencer.name,
        id: this.influencer.id,
      });
    }
  }

  closeErrorAddingInfluencerAlert() {
    if (this.addInfluencerToGroupErrorPopupRef) {
      this.modalService.closeSinglePopup(this.addInfluencerToGroupErrorPopupRef);
    }
  }

  showAlertSuccessAddInfluencerToGroup(addForReview) {
    if (addForReview) {
      this.addInfluencerToGroupSuccessMessage = this.translateService.instant('group_details.influencer.add_influencer_as_pending');
    } else {
      this.addInfluencerToGroupSuccessMessage = this.translateService.instant('group_details.influencer.add_influencer_to_group');
    }
    this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
  }

  showAlertSuccessAddInfluencerToCampaign() {
    this.modalService.open(this.alertAddInfluencerToCampaignSuccess, undefined, true);
  }

  hideAlertSuccess() {
    this.modalService.close();
  }

  openCreateNewGroupFragment(evt) {
    this.pendingAddInfluencerToGroup = evt;
    this.isEnableAddToGroup = false;
    this.showCreateNewGroupFragment = true;
  }

  cancelCreateGroup() {
    this.showCreateNewGroupFragment = false;
    this.isEnableAddToGroup = true;
  }

  afterCreateGroupSuccess(persistedGroup) {
    this.showCreateNewGroupFragment = false;
    this.isEnableAddToGroup = true;
    const companyId = this.userService.getCompanyId();
    // load list influencer group
    this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe((res: any) => {
      this.influencerGroupList = res.map(group => ({
        id: group.id,
        name: group.name,
        description: group.description
      }));
      // Find the new group and add the selected influencers to new group
      const newGroup = res.find((group) => group.name === persistedGroup.data.name);
      if (newGroup && this.addInfluencerToGroup) {
        this.addInfluencerToGroup.influencerGroup.influencer_group_id = newGroup.id;
        this.addInfluencerToGroup.influencerGroup.influencerGroupName = newGroup.name;
        this.addInfluencerToGroup.influencerGroup.description = newGroup.description;
      }
    });
  }

  public onSelectedInfluencerCampaignChanged(e: InfluencerCampaignActivity) {
    this.selectedInfluencerCampaign = new InfluencerCampaignActivity();
    this.selectedInfluencerCampaign.id = e.campaignId;
    this.selectedInfluencerCampaign.name = e.name;
    this.selectedInfluencerCampaign.campaignInfluencerId = e.campaignInfluencerId;
    this.isArchivedCampaign = e.campaignType === CampaignInfluencerStatus.ARCHIVED;
  }

  public removeFromCampaignConfirmation() {
    this.modalService.openInCenter(this.confirmRemoveFromCampaign);
  }

  public removeFromCampaign() {
    const campaignInfluencerId = this.selectedInfluencerCampaign.campaignInfluencerId;
    this.campaignService.deleteInfluencerFromCampaign(campaignInfluencerId).subscribe((res: any) => {
      this.influencerCampaignActivity.clearCachedData(campaignInfluencerId);
      this.influencerCampaignActivity.clearSelectionAndReset();
      this.clearCachedCampaignInfluencersData(this.selectedInfluencerCampaign.id);
      this.hideAlertSuccess();
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
        id: this.selectedInfluencerCampaign.id,
        name: this.selectedInfluencerCampaign.name,
        type: TargetType.CAMPAIGN
      }, {
        action: UserActionType.UPDATE,
        actionDetails: ActionDetails.REMOVED_INFLUENCERS,
        source: ActionSource.BOTTOM_BAR,
        influencers: [this.influencerId]
      }, undefined, this.activePage);
      this.userService.triggerUpdateActivatedInfluencers();
    });
  }

  public openCampaignInReports() {
    this.router.navigate(['/measure/'], { queryParams: {campaign_id: this.selectedInfluencerCampaign.id} });
  }

  public goToCampaignOverview() {
    this.router.navigate(['/campaigns/' + this.selectedInfluencerCampaign.id]);
  }

  public exportPdfReport(popper) {
    if (this.influencerService.isCreditAvailable() === false) {
      const errorMsg = this.translateService.instant('INFLUENCER.insight.fallback_msg', {
        maxCredit: this.userService.maxActiveInfluencers
      });
      this.userService.doInvalidActionByLevel('Branded Exports', errorMsg);
    }
    if (this.influencerService.isCreditAvailable() === true && popper) {
      popper.hide();
      this.downloadPDF();
    }
  }

  public downloadPDF() {
    // cancel previous request
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
    this.exportPdfSubcription = this.pdfViewerService.generateInfluencerDetailPdf(this.influencerId, this.demographicChannelParam,
      this.userService.getCompanyId(), this.channelFollowerParam, this.insightChannelParam)
      .subscribe({
        next: () => { this.userService.triggerUpdateActivatedInfluencers(); },
        error: error => this.handleExportError(error)
      });
    this.sendMixpanelEvent();
  }

  private handleExportError(error: Error): void {
    if (error && error instanceof HttpErrorResponse) {
      const innerErrorData = error.error && error.error.data;

      if (innerErrorData === 'invalid_account_level') {
        this.closeModalPopup();
        this.notifyPdfExportErrorMessage = error.error.message;
        this.modalService.open(this.notifyPdfExportError, null, true);
      }
    }
  }

  private sendMixpanelEvent() {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER, {
      id: this.influencerId,
      name: this.influencerName,
      type: TargetType.INFLUENCER
    }, {
      action: UserActionType.EXPORT
    }, undefined, null, null);
  }

  get influencerName() {
    return this.influencer ? this.influencer.name : '';
  }

  get platformBackground() {
    return this.userService.platformBackground;
  }

  private getActivePageType(activeTabIndex: number): string {
    switch (activeTabIndex) {
      case InfluencerTab.OVERVIEW: {
          return ActivePages.INFLUENCER_OVERVIEW;
      }
      case InfluencerTab.INSIGHT: {
          return ActivePages.INFLUENCER_INSIGHTS;
      }
      case InfluencerTab.DEMOGRAPHIC: {
          return ActivePages.INFLUENCER_DEMOGRAPHICS;
      }
      case InfluencerTab.CAMPAIGN: {
          return ActivePages.INFLUENCER_CAMPAIGNS;
      }
      default:
          return ActivePages.INFLUENCER_OVERVIEW;
    }
  }

  get activePage(): ActivePage {
    return {
      type: this.getActivePageType(this.activeTabIndex),
      name: this.influencer.name,
      id: this.influencer.id,
    };
  }

  /**
   * Defined data will be sent to Segment when free user click on Campaign Tab
   * @returns {{action: UserActionType; item: Page; target: {id: number; name: string; type: TargetType}}}
   */
  get campaignActionData() {
    if (!this.influencer) {
      return null;
    }
    return {
      action: UserActionType.VIEW,
      item: Page.INFLUENCER_CAMPAIGNS,
      target: {
        id: this.influencer.id,
        name: this.influencer.name,
        type: TargetType.INFLUENCER
      }
    };
  }

  get isActiveOverviewTab() {
    return this.activeTabIndex === InfluencerTab.OVERVIEW;
  }

  get isActiveInsightTab() {
    return this.activeTabIndex === InfluencerTab.INSIGHT;
  }

  get isActiveDemographicTab() {
    return this.activeTabIndex === InfluencerTab.DEMOGRAPHIC;
  }

  get isActiveActivityTab() {
    return this.activeTabIndex === InfluencerTab.ACTIVITY;
  }

  get isActiveCampaignTab() {
    return this.activeTabIndex === InfluencerTab.CAMPAIGN;
  }

  get isDisableActivityTab() {
    return this.userService.isFreeUser() || AppSettings.isDisableChat();
  }

  get hasSelectedPostToDelete() {
    return Array.isArray(this.postToDelete) && this.postToDelete.length > 0 && this.campaignNeedToDeletePost;
  }
  /**
   * Defined data will be sent to Segment when free user click on 'Add Grouo' or 'Add to Campaign' button
   * @returns {{action: UserActionType; item: Page; target: {id: number; name: string; type: TargetType}}}
   */
  invalidActionData(forGroup) {
    if (!this.influencer) {
      return null;
    }
    return {
      action: UserActionType.ACTION,
      item: forGroup ? Page.GROUP : Page.CAMPAIGN,
      target: {
        id: this.influencer.id,
        name: this.influencer.name,
        type: forGroup ? TargetType.INFLUENCER_GROUP : TargetType.CAMPAIGN
      },
      params: {
        action: UserActionType.UPDATE,
        source: ActionSource.BOTTOM_BAR,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
      },
      activePage: this.activePage
    };
  }

  closeModalPopup() {
    this.modalService.close();
  }

  public contactSupport() {
    this.userService.contactSupport();
  }

  public onSelectPostToDelete(campaignPostDelete) {
    this.postToDelete = campaignPostDelete.posts;
    this.campaignNeedToDeletePost = campaignPostDelete.campaignId;
  }

  public confirmBeforeDeleteingPost() {
    this.modalService.openInCenter(this.confirmDeletePostFromCampaign, null);
  }

  public onDeletePostFromCampaign() {
    this.closeModalPopup();
    this.campaignService.deletePostFromCampaign(this.campaignNeedToDeletePost, this.postToDelete).subscribe((res) => {
      const deletedPostUrlHashs = this.postToDelete.map(p => p.urlHash);
      this.campaignNeedToDeletePost = null;
      this.postToDelete = null;
      this.modalService.open(this.notifyPostDeletedSuccess, null, true);
      if (this.influencerCampaignActivity) {
        this.influencerCampaignActivity.campaignPosts = this.influencerCampaignActivity.campaignPosts
          .filter(cp => deletedPostUrlHashs.indexOf(cp.urlHash) < 0);
        this.influencerCampaignActivity.clearCachedData(this.campaignInfluencerId);
      }
      this.clearCachedCampaignInfluencersData(this.selectedInfluencerCampaign.id);
    }, (error) => {
      this.modalService.open(this.notifyPostDeletedError, null, true);
    });
  }

  private getCachingKeys(companyId, influencerId, campaignInfluencerId?) {
    const cachedKeys = [
      `group_list_${companyId}`,
      `campaign_list_${companyId}`,
      `influencer_${influencerId}`,
      `influencer_top_exposures_${influencerId}`,
      `influencer_daily_kpis_${influencerId}`,
      `influencer_posts_${influencerId}`,
      `influencer_best_performing_${influencerId}`,
      `influencer_audience_data_${influencerId}`
    ];
    if (campaignInfluencerId) {
      cachedKeys.push(`campaign_influencer_${campaignInfluencerId}`);
      cachedKeys.push(`campaign_influencer_details_${campaignInfluencerId}`);
      cachedKeys.push(`campaign_influencer_list_${campaignInfluencerId}`);
    }
    return cachedKeys;
  }

  private clearCachedCampaignInfluencersData(campaignId) {
    this.cacheService.clear(`campaign_influencers_${campaignId}`);
    this.cacheService.clear(`campaign_details_influencers_${campaignId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer.component.ts